import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { JarowaWorkorderInfo } from '../../../../app-create-case/models/basic-information.model';
import { ShellDomainProvider } from '../../../standalone-packages/ecap3/core';
import { CommonService } from '../../../services/common.service';
import { SCConfig } from '../../../../sc-config/constant/sc-config.constant';

@Component({
    selector: 'app-linked-jarowa-cases',
    templateUrl: './linked-jarowa-cases.component.html',
    styleUrls: ['./linked-jarowa-cases.component.scss'],
    standalone: false
})
export class AppLinkedJarowaCasesComponent {
    //Input section
    @Input() jarowaWorkorderInfo: JarowaWorkorderInfo;
    JarowaConnectedWorkorderUrl = `${ShellDomainProvider['api'].JarowaWorkorderUrl}`;
    constructor(
        private router: Router,
        public readonly translateService: TranslateService,
        private commonService: CommonService
    ) {}

    get isSystemAdminOrAdmin(): boolean {
        const roles = this.commonService.currentLoggedInUser?.Roles;
        return !!(roles?.includes(SCConfig.CurrentRole.SystemAdmin) || roles?.includes(SCConfig.Roles.Admin));
    }

    getJarowaWorkorderUrl() {
        return this.JarowaConnectedWorkorderUrl.replaceAll('WORKORDER_ID', this.jarowaWorkorderInfo?.WorkorderId || '');
    }

    navigateToYarowaCockpit(event: MouseEvent) {
        event.preventDefault();
        event.stopPropagation();
        if (this.jarowaWorkorderInfo?.WorkorderId) {
            const url = this.router.serializeUrl(
                this.router.createUrlTree(['/master-data/yarowa-cockpit', this.jarowaWorkorderInfo.WorkorderId])
            );
            window.open(url, '_blank');
        }
    }
}
